enum ProviderKey {
  FBA = 'FBA',
  SHIP = 'SHIP',
}

export default ProviderKey;
